// libs
import React, { useState, useEffect, memo, useMemo } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// Local components
import MetaInfo from 'shared/components/AdPlatformWidgets/components/MetaInfo';
import Story from 'shared/components/AdPlatformWidgets/components/Story';
import Carousel from './components/Carousel';
import Grid from './components/Grid';
import SlidingWidget from './components/SlidingWidget';
import InFocus from './components/InFocus';
import ImpressionTracking from 'shared/components/AdPlatformWidgets/ImpressionTracking';
import SplitBanner from './components/SplitBanner';

// types
import { ILandingPageProps } from 'shared/components/AdPlatformWidgets/types';

// helpers
import { WIDGET_TYPES, SSR_CSR_SPLIT } from 'shared/components/AdPlatformWidgets/constants';
import { getMetaData, transformLandingData } from 'shared/components/AdPlatformWidgets/helpers';

// styles
import { WidgetsContainer } from 'shared/components/AdPlatformWidgets/styles';

const COMPONENTS = {
  [WIDGET_TYPES.CAROUSEL]: Carousel,
  [WIDGET_TYPES.COLUMN_GRID]: Grid,
  [WIDGET_TYPES.TEXT_GRID]: Grid,
  [WIDGET_TYPES.DATA_WIDGET]: SlidingWidget,
  [WIDGET_TYPES.RECOMMENDATION_WIDGET]: SlidingWidget,
  [WIDGET_TYPES.SLIDING_WIDGET]: SlidingWidget,
  [WIDGET_TYPES.IN_FOCUS]: InFocus,
  [WIDGET_TYPES.STORY]: Story,
  [WIDGET_TYPES.SPLIT_BANNERS]: SplitBanner,
};

function AdPlatformWidgetsDesktop({ landingPageData }: ILandingPageProps) {
  const [landingData, setLandingData] = useState(landingPageData.slice(0, SSR_CSR_SPLIT));
  const metaData = getMetaData(landingPageData);

  useEffect(() => {
    setLandingData(landingPageData);
  }, [landingPageData]);

  const landingDataWithTracking = useMemo(() => transformLandingData(landingData), [landingData]);

  const Elements = landingDataWithTracking.map((widget, id) => {
    const Component = COMPONENTS[get(widget, 'widget_data.wtype')];

    if (isEmpty(Component)) return null;

    return <Component key={id} widget={widget} />;
  });

  return (
    <main>
      <ImpressionTracking platform="desktop">
        <MetaInfo metaData={metaData} />
        <WidgetsContainer>{Elements}</WidgetsContainer>
      </ImpressionTracking>
    </main>
  );
}

export default memo(AdPlatformWidgetsDesktop);
